import styled from 'styled-components';
import { ReactComponent as IconVulnerability_ } from 'Images/vulnerabilities.svg';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 34px;
  align-items: center;
  width: 94%;
  & > :not(:last-child) {
    margin-right: 5px;
  }
`;
Wrapper.displayName = 'Wrapper';

export const InputTitle = styled.input`
  padding-right: 10px;
  margin: auto 5px auto 0px;
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.text.detailModalTitle};
  border: none;
  cursor: pointer;
  border-radius: 5px;
  background-color: transparent;

  &:focus {
    cursor: text;
    color: ${({ theme }) => theme.text.detailNameHover};
  }

  &:not(:focus) {
    &:hover {
      color: ${({ theme }) => theme.text.detailNameHover};
      background-color: ${({ theme }) => theme.textfield.background};
    }
  }

`;
InputTitle.displayName = 'InputTitle';

export const DuplicateWrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 25px;
  border-radius: 6px;
  background-color: #bec8d2;
  padding: 3px 8px;
  margin-right: 10px;
`;
DuplicateWrapper.displayName = 'DuplicateWrapper';

export const IconVulnerability = styled(IconVulnerability_)`
  margin-right: 11px !important;
  path {
    fill: ${({ theme }) => theme.icons.detailModalTitle.color};
    stroke: ${({ theme }) => theme.icons.detailModalTitle.color};
    stroke-width: 0.5;
  }
`;
IconVulnerability.displayName = 'IconVulnerability_';
